import React from 'react'
// import Top from "../common/fixedbar";
// import Header from "../common/header/header1";
import '../../styles/helpAndSupport/helpAndSupport.scss';
import HeaderNonSrp from '../header/headerNonSrp';
import SubHeader from '../header/subHeader';
import Footer from '../footer/footer';


const HelpAndSupport = (props) => {

    const { history } = props;

    // const goBack = () => {
    //     if (window.appPage == "true") {
    //         window.location.href = "/?gotohome=true";
    //     } else {
    //         history.goBack();
    //     }
    // };

    return (
        <div className='guest--cancel--wrapper'>
            {/* <Top>
                <Header
                    head="Help and Support"
                    onBack={goBack}
                />
            </Top> */}
            <HeaderNonSrp />
            <SubHeader />
            <div className="helpAndSupportContainer">
                <div className='help--support--head' style=
                    {{
                        color: '#202020',
                        fontWeight: '600',
                        letterSpacing: '0.01rem'
                    }}>{`Help and Support`}</div>
                <div className="contactBlock">
                    <div className="contactBlockHeader">KSRTC Call Centre (24/7)</div>
                    <div className="contactBlockBody">
                        <div className="contactWrapper">
                            <div className='col1'>Contact Number</div>
                            <div className='col2'>:</div>
                            <div className='col3'>080-26252625</div>
                        </div>
                        <div className="contactWrapper2" style={{ height: '60px' }}>
                            &nbsp;
                        </div>
                    </div>
                </div>

                <div className="contactBlock">
                    <div className="contactBlockHeader">For Booking Related Queries <br /> (AWATAR Cell)</div>
                    <div className="contactBlockBody">
                        <div className="contactWrapper">
                            <div className='col1'>Contact Numbers</div>
                            <div className='col2'>:</div>
                            <div className='col3'>7760990034 / 7760990035 </div>
                        </div>
                        <div className="contactWrapper2" style={{ height: '60px' }}>
                            (Between 07:00-22:00 hrs on all days)
                        </div>
                    </div>
                </div>

                <div className="contactBlock" style={{paddingBottom:'15px'}}>
                    <div className="contactBlockHeader">For Refund & Failure Transactions<br />(Accounts Dept.)</div>
                    <div className="contactBlockBody">
                        <div className="contactWrapper">
                            <div className='col1'>Contact Numbers</div>
                            <div className='col2'>:</div>
                            <div className='col3'>7618765800 / 7618765900</div>
                        </div>
                        <div className="contactWrapper2" style={{ height: '60px' }}>
                            (Between 10:00 - 17:30 hrs. on Monday - Fridays
                            <br />10:00 - 13:30 hrs. on Saturdays)
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default HelpAndSupport;